// extracted by css-extract-rspack-plugin
export default {"fullPageAppTemplate":"src-modules-app-registry-templates-FullPageAppTemplate-FullPageAppTemplate-module__fullPageAppTemplate-U5v31_","publicRoute":"src-modules-app-registry-templates-FullPageAppTemplate-FullPageAppTemplate-module__publicRoute-iJHiyW","hideContent":"src-modules-app-registry-templates-FullPageAppTemplate-FullPageAppTemplate-module__hideContent-X2c1Ms","fullHeight":"src-modules-app-registry-templates-FullPageAppTemplate-FullPageAppTemplate-module__fullHeight-ccvPTq"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"fullPageAppTemplate\":\"src-modules-app-registry-templates-FullPageAppTemplate-FullPageAppTemplate-module__fullPageAppTemplate-U5v31_\",\"publicRoute\":\"src-modules-app-registry-templates-FullPageAppTemplate-FullPageAppTemplate-module__publicRoute-iJHiyW\",\"hideContent\":\"src-modules-app-registry-templates-FullPageAppTemplate-FullPageAppTemplate-module__hideContent-X2c1Ms\",\"fullHeight\":\"src-modules-app-registry-templates-FullPageAppTemplate-FullPageAppTemplate-module__fullHeight-ccvPTq\"}";
        // 1793873545962
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  